import { CompanyDetailsProps } from "./uploadApi";


interface ViewCompanyDetailsProps {
    comapanyData: CompanyDetailsProps
}

const ViewCompanyDetails = ({ comapanyData }: ViewCompanyDetailsProps) => {
    console.log("View comapany details in view tab: ", comapanyData);

    if (!comapanyData) {
        return (
            <span>No Data Availabe, please add company data</span>
        )
    }

    return (
        <div className="dark:text-table-textDark">
            <div >
                <span>Company Name : </span>
                <span>{comapanyData.companyName} </span>
            </div>

            <div>
                <span>Company Logo : </span>
                <img src={comapanyData.logoUrl} alt="logo" />
            </div>

        </div>
    )

}

export default ViewCompanyDetails;